<template>
  <div v-if="condition">
    <div class="d-flex pt-2 justify-content-between align-items-center">
      <span class="mr-3">{{ $t(filter.subline) }}</span>
      <Buttons
        :state="buttonState"
        @setFilter="handleSetFilter"
      />
    </div>
  </div>
</template>

<script>
import Buttons from '@/components/form/Buttons'

export default {
  components: { Buttons },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    condition: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    buttonState () {
      return this.filter.state || 'all'
    },
  },
  methods: {
    handleSetFilter(newValue){
      this.$emit('setFilter', { selectedFilter: { ...this.filter, state: newValue } })
    },
  },
}
</script>
